<cyborg-banner
  *ngIf="status === statusTypes.TRIAL"
  (click)="openPremiumDialog()"
>
  <ng-container *ngIf="daysRemaining > daysThreshold; else showCountdown">
    You're using HUNTER Community. Talk to an Intel 471 Expert today about
    Premium access.
  </ng-container>
  <ng-template #showCountdown>
    You have <strong>{{ daysRemaining }}</strong> days left of HUNTER Community.
    Talk to an Intel 471 Expert today about extending your access.
  </ng-template>
  <strong>Learn more.</strong>
</cyborg-banner>
<div *ngIf="!isiFrame" class="wrapper">
  <div>
    <div class="row top">
      <div>
        <a
          [class.active-route]="isActive('/research')"
          routerLink="/research"
          class="logo desktop"
        >
          <img class="intel-logo" src="/assets/brand/intel-logo-light.svg" />
        </a>
        <a
          [class.active-route]="isActive('/research')"
          routerLink="/research"
          class="logo mobile"
          ><img src="/assets/brand/intel-bug-light.svg"
        /></a>
      </div>
      <div *ngIf="loggedIn" class="options">
        <div id="menu-outer">
          <div class="table">
            <ul id="horizontal-list">
              <li>
                <a
                  [class.active-route]="isActive('/research')"
                  routerLink="/research"
                  >Research</a
                >
              </li>
              <li *ngIf="huntModuleAccess; else noAccess">
                <a
                  [class.active-route]="isActive('/hunt')"
                  routerLink="/hunt/dashboard"
                  >Hunt</a
                >
              </li>
              <ng-template #noAccess>
                <li>
                  <img
                    style="margin-right: 5px"
                    width="25"
                    height="25"
                    src="/assets/img/icons/cyborg-premium-icon.png"
                  />
                  <a (click)="openHuntDialog()">Hunt</a>
                </li>
              </ng-template>
            </ul>
          </div>
        </div>
        <div class="account">
          <img src="{{ avatar }}" class="avatar" />
          <div class="panel">
            <div class="user">
              <img src="{{ avatar }}" class="avatar" />
              <div class="about">
                <p>{{ firstName }} {{ lastName }}</p>
                <span
                  >{{ role }}
                  &#x2022;
                  <ng-container *ngIf="status === statusTypes.TRIAL">
                    Community
                  </ng-container>
                  <ng-container *ngIf="status === statusTypes.ACTIVE">
                    Premium
                  </ng-container>
                  <ng-container *ngIf="status === statusTypes.POC">
                    Prospect
                  </ng-container>
                </span>
              </div>
            </div>
            <cyborg-button
              *ngIf="status === statusTypes.TRIAL"
              color="outline"
              size="small"
              (click)="openPremiumDialog()"
            >
              <img
                style="margin-right: 5px"
                width="16"
                height="16"
                src="/assets/img/icons/cyborg-premium.png"
              />
              Upgrade your plan
            </cyborg-button>
            <ul>
              <li>
                <a routerLink="/settings" title="Settings">Settings</a>
              </li>
              <li>
                <a routerLink="/customer-support" title="Contact"> Contact </a>
              </li>
            </ul>
            <div class="new" routerLink="/releases">
              Check out what's new in Version {{ latest }}
            </div>
            <a routerLink="" class="logout" (click)="onLogOut()"
              >Logout <i class="k-icon k-font-icon k-i-logout"></i
            ></a>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
